import { apiService } from './api';

export type ReservationStatus = 'BOOKED' | 'SEATED' | 'COMPLETED' | 'CANCELLED' | 'NO_SHOW';

export interface Reservation {
  id: string;
  customerName: string;
  customerMobile?: string;
  partySize?: number;
  reservationTime: string;     // yyyy-MM-ddTHH:mm
  durationMinutes?: number;
  tableId?: string;
  tableName?: string;
  status: ReservationStatus;
  notes?: string;
  organizationCode: string;
  restaurantId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateReservationRequest {
  customerName: string;
  customerMobile?: string;
  partySize?: number;
  reservationTime: string;
  durationMinutes?: number;
  tableId?: string;
  notes?: string;
  organizationCode: string;
  restaurantId?: string;
}

export const reservationService = {
  async list(org: string, restaurantId?: string, date?: string, status?: ReservationStatus): Promise<Reservation[]> {
    const response = await apiService.get<Reservation[]>('/reservations', {
      org,
      ...(restaurantId && { restaurantId }),
      ...(date && { date }),
      ...(status && { status }),
    });
    return response.data;
  },

  async create(data: CreateReservationRequest): Promise<Reservation> {
    const response = await apiService.post<Reservation>('/reservations', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateReservationRequest>): Promise<Reservation> {
    const response = await apiService.put<Reservation>(`/reservations/${id}`, data);
    return response.data;
  },

  async setStatus(id: string, status: ReservationStatus): Promise<Reservation> {
    const response = await apiService.patch<Reservation>(`/reservations/${id}/status`, { status });
    return response.data;
  },

  async remove(id: string): Promise<void> {
    await apiService.delete(`/reservations/${id}`);
  },
};
